import classNames from 'classnames'
import React from 'react'
import { Container } from 'src/components/framework/ui'
import { Legal } from 'src/components/page/layout/footer/legal'
import { Logos } from 'src/components/page/layout/footer/logos'
import { SiteLinks } from 'src/components/page/layout/footer/site-links'

import * as styles from './footer.module.scss'

export const Footer: React.FC = () => {
  return (
    <>
      <footer
        className={classNames(styles.footer, 'enhance-colors', 'stk-border-t')}
      >
        <div className="stk-text-small">
          <Container className="stk-space-in-3 stk-space-in-t-6 stk-space-in-b-6">
            <SiteLinks />
          </Container>
          <div className="stk-space-in-3 stk-space-in-t-6 stk-space-in-b-6 stk-border-t">
            <Container>
              <Logos />
              <Legal />
            </Container>
          </div>
        </div>
      </footer>
    </>
  )
}
